import React, {useEffect, useState} from 'react';
import {CustomInput, Label} from 'reactstrap';
import {components} from 'react-select';
import {SelectBase} from 'components/Forms/FormBases';
import LocalStorage from 'utils/localStorage';
import {isEmpty, isEqual} from 'lodash';
import {getPublicIndustries} from 'api/common';
import {alertByError} from 'utils/alerts';

SelectIndustry.defaultProps = {
  optionLabel: 'industry_name',
  optionValue: 'industry_id',
};

const Option = (props) => {
  const {isSelected, label, ...rest} = props;

  return (
    <div>
      <components.Option {...rest}>
        <div
          className="d-flex align-items-center"
          onClick={(e) => e.preventDefault()}
        >
          <CustomInput
            id={label}
            type="checkbox"
            checked={isSelected}
            onChange={() => null}
            className="mr-2 d-inline"
          />
          <Label className="mb-0">{label}</Label>
        </div>
      </components.Option>
    </div>
  );
};

function SelectIndustry(props) {
  const {name, defaultValue, optionLabel, optionValue, onChange, ...rest} =
    props;
  const storedData = LocalStorage.industries || [];

  const [states, setStates] = useState({
    isLoading: isEmpty(storedData),
    data: storedData,
  });

  useEffect(() => {
    if (isEmpty(storedData)) {
      getIndustries();
    }
  }, []);

  async function getIndustries() {
    try {
      const {data} = await getPublicIndustries();

      const filteredData = data.filter(
        (item) => !isEqual(item.industry_code, 'certorg')
      );

      LocalStorage.industries = filteredData;
      setStates({isLoading: false, data: filteredData});
    } catch (e) {
      setStates((prevStates) => ({...prevStates, isLoading: false}));
      await alertByError(e);
    }
  }

  const {isLoading, data} = states;

  return (
    <SelectBase
      isMulti
      isLoading={isLoading}
      components={{Option}}
      getOptionLabel={(option) => option[optionLabel]}
      getOptionValue={(option) => option[optionValue]}
      allowSelectAll={true}
      closeMenuOnSelect={false}
      onChange={(selected) => onChange(selected)}
      hideSelectedOptions={false}
      blurInputOnSelect={false}
      defaultValue={defaultValue}
      options={data}
      {...rest}
    />
  );
}

export default SelectIndustry;
